<template>
  <div>
    <div class="py-2 text-general">
      <div class="px-2 d-flex justify-content-between align-items-center">
        <label class="header-text font-weight-bold">ลูกค้า</label>
        <b-button
          class="filter-slide-btn d-flex align-items-center"
          @click="showFilter"
          ><font-awesome-icon icon="filter" title="filter-btn" />
          <span class="mx-2 font-weight-bold">กรองข้อมูล</span>
          <font-awesome-icon
            :color="$store.state.colorPrimary"
            icon="chevron-circle-left"
            title="filter-btn"
          />
        </b-button>
      </div>
      <div>
        <b-table
          responsive
          class="mt-2 text-center table-list mb-0 table-p-th"
          hover
          :tbody-tr-class="trTableReport"
          :fields="fields"
          :items="items"
          :busy="isBusy"
          show-empty
          empty-text="ไม่มีรายการข้อมูลการซื้อ"
        >
          <template v-slot:head(member_id)="">
            <p class="mb-0">หมายเลขสมาชิก</p>
            <p class="mb-0">(Member ID)</p>
          </template>
          <template v-slot:head(first_name_th)="">
            <p class="mb-0">ชื่อสมาชิก</p>
            <p class="mb-0">(Name)</p>
          </template>
          <template v-slot:head(telephone)="">
            <p class="mb-0">หมายเลขโทรศัพท์</p>
            <p class="mb-0">(Phone no.)</p>
          </template>
          <template v-slot:head(email)="">
            <p class="mb-0">อีเมล</p>
            <p class="mb-0">(Email)</p>
          </template>
          <template v-slot:head(frequency)="">
            <p class="mb-0">ความถี่ในการซื้อ</p>
            <p class="mb-0">(Frequency)</p>
          </template>
          <template v-slot:head(branch_spend)="">
            <p class="mb-0">ยอดสะสมสาขาสุทธิ</p>
            <p class="mb-0">(Current Branch Spending)</p>
          </template>
          <template v-slot:head(other_spend)="">
            <p class="mb-0">ยอดสะสมต่างสาขาสุทธิ</p>
            <p class="mb-0">(Other Branch Spending)</p>
          </template>
          <template v-slot:head(birthday)="">
            <p class="mb-0">วัน/เดือน/ปีเกิด</p>
            <p class="mb-0">(Birthday)</p>
          </template>
          <template v-slot:head(last_purchase)="">
            <p class="mb-0">วันล่าสุดที่ซื้อ</p>
            <p class="mb-0">(Last purchase date)</p>
          </template>
          <template v-slot:cell(member_id)="data">
            <div v-if="data.item.member_id">
              <label>{{ data.item.member_id }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(first_name_th)="data">
            <div v-if="data.item.first_name_th">
              <label>{{ data.item.first_name_th }}</label
              ><label class="ml-2">{{ data.item.last_name_th }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(telephone)="data">
            <div v-if="data.item.telephone">
              <label>{{ data.item.telephone }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(email)="data">
            <div v-if="data.item.email">
              <label>{{ data.item.email }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(frequency)="data">
            <div v-if="data.item.frequency >= 0">
              <label>{{ data.item.frequency | numeral("0,0") }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(branch_spend)="data">
            <div v-if="data.item.branch_spend >= 0">
              <label>{{ data.item.branch_spend | numeral("0,0") }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(other_spend)="data">
            <div v-if="data.item.other_spend >= 0">
              <label>{{ data.item.other_spend | numeral("0,0") }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(birthday)="data">
            <div v-if="data.item.birthday">
              <label>{{
                new Date(data.item.birthday) | moment($formatDateTime)
              }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(last_purchase)="data">
            <div v-if="data.item.last_purchase">
              <label>{{
                new Date(data.item.last_purchase) | moment($formatDateTime)
              }}</label>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
        </b-table>
        <div class="mt-2">
          <b-pagination
            size="sm"
            limit="4"
            v-model="filter.page"
            :total-rows="rows"
            :per-page="filter.perPage"
            class="m-md-0 page-item"
            @change="pagination"
            align="center"
          ></b-pagination>
        </div>
      </div>
      <SlideFilter
        ref="SlideFilter"
        :filter="filter"
        :yearConfig="yearConfig"
        :monthConfig="monthConfig"
        :newCustomerMonthConfig="newCustomerMonthConfig"
        :monthNoConfig="monthNoConfig"
        :spendingConfig="spendingConfig"
        :frequencyConfig="frequencyConfig"
        :genderConfig="genderConfig"
        :sortbyConfig="sortbyConfig"
        @onSubmitFilter="getCustomerList"
      />
      <ModalLoading ref="modalLoading" :hasClose="false" />
    </div>
  </div>
</template>

<script>
import SlideFilter from "./components/SlideFilter.vue";
import ModalLoading from "@/components/modal/alert/ModalLoading";
export default {
  name: "CustomerIndex",
  components: {
    SlideFilter,
    ModalLoading,
  },
  data() {
    return {
      isBusy: false,
      filter: {
        telephone: "",
        name: "",
        year: "0",
        birthdayMonth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        newRegisterMonth: "0",
        currentSpending: "0",
        otherSpending: "0",
        returnMonth: "0",
        frequency: "0",
        gender: "0",
        sortBy: "1",
        page: 1,
        perPage: 8,
      },
      rows: 0,
      items: [],
      fields: [
        {
          key: "member_id",
          label: "หมายเลขสมาชิก",
          class: "text-nowrap",
          thStyle: {
            "min-width": "150px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
        {
          key: "first_name_th",
          label: `ชื่อสมาชิก`,
          class: "text-nowrap",
          thStyle: {
            "min-width": "250px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
        {
          key: "telephone",
          label: `หมายเลขโทรศัพท์`,
          class: "text-nowrap",
          thStyle: {
            "min-width": "150px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
        {
          key: "email",
          label: `อีเมล`,
          class: "text-nowrap",
          thStyle: {
            "min-width": "150px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
        {
          key: "frequency",
          label: `ความถี่ในการซื้อ`,
          class: "text-nowrap",
          thStyle: {
            "min-width": "150px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
        {
          key: "branch_spend",
          label: `ยอดสะสมสาขาสุทธิ`,
          class: "text-nowrap",
          thStyle: {
            "min-width": "150px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
        {
          key: "other_spend",
          label: `ยอดสะสมต่างสาขาสุทธิ`,
          class: "text-nowrap",
          thStyle: {
            "min-width": "150px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
        {
          key: "birthday",
          label: `วัน/เดือน/ปีเกิด`,
          class: "text-nowrap",
          thStyle: {
            "min-width": "150px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
        {
          key: "last_purchase",
          label: `วันล่าสุดที่ซื้อ`,
          class: "text-nowrap",
          thStyle: {
            "min-width": "150px",
            color: this.$store.state.colorPrimary,
            "background-color": this.LightenDarkenColor(
              this.$store.state.colorSecondary,
              90
            ),
            opacity: "0.81",
            "border-bottom": `2px solid ${this.$store.state.colorPrimary}`,
          },
        },
      ],
      trTableReport: {
        "border-bottom": "1px solid #D9D9D9",
      },
      yearConfig: [],
      monthConfig: [],
      newCustomerMonthConfig: [],
      monthNoConfig: [],
      spendingConfig: [],
      frequencyConfig: [],
      genderConfig: [],
      sortbyConfig: [],
    };
  },
  async created() {
    await this.getFilterConfig();
    this.getCustomerList();
  },
  methods: {
    getCustomerList() {
      this.isBusy = true;
      this.axios
        .post(`${this.$baseUrl}/customer/get_userdirectory`, this.setBody())
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail;
            this.rows = data.total_count;
          }
          this.isBusy = false;
        });
    },
    showFilter() {
      this.$refs.SlideFilter.show();
    },
    async getFilterConfig() {
      this.axios.get(`${this.$baseUrl}/dropdown/get_year_list`).then((data) => {
        this.yearConfig = data.detail;
        this.yearConfig.splice(0, 0, { id: "0", name: "ทั้งหมด", year: 0 });
      });
      this.axios
        .get(`${this.$baseUrl}/dropdown/get_month_list`)
        .then((data) => {
          this.monthConfig = data.detail.filter((m) => m.id != "0");
          this.newCustomerMonthConfig = data.detail;
          this.monthNoConfig = data.detail.map((m, i) => {
            let data = {};
            if (m.id == "0") {
              data = m;
            } else {
              data = { id: m.id, name: m.id, year: m.year };
            }
            return data;
          });
        });
      this.axios
        .get(`${this.$baseUrl}/dropdown/get_spending_range`)
        .then((data) => {
          this.spendingConfig = data.detail;
        });
      this.axios
        .get(`${this.$baseUrl}/dropdown/get_purchase_frequency_list`)
        .then((data) => {
          this.frequencyConfig = data.detail;
          this.frequencyConfig.splice(0, 0, {
            id: "0",
            name: "ไม่ระบุ",
            year: 0,
          });
        });
      this.axios.get(`${this.$baseUrl}/dropdown/get_gender`).then((data) => {
        this.genderConfig = data.detail;
      });
      this.axios
        .get(`${this.$baseUrl}/dropdown/get_sortby_list`)
        .then((data) => {
          this.sortbyConfig = data.detail;
        });
    },
    pagination(Page) {
      this.filter.page = Page;
      this.getCustomerList();
    },
    setBody() {
      return {
        branch_id: this.$cookies.get("branch_id"),
        skip: (this.filter.page - 1) * this.filter.perPage,
        take: this.filter.perPage,
        telephone: this.filter.telephone,
        name: this.filter.name,
        year: this.filter.year,
        birthday_month: this.filter.birthdayMonth
          .sort(function (a, b) {
            return a - b;
          })
          .join(),
        new_register_month: this.filter.newRegisterMonth,
        current_spending: this.filter.currentSpending,
        other_spending: this.filter.otherSpending,
        return_month: this.filter.returnMonth,
        no_return_month: "",
        frequency: this.filter.frequency,
        gender: this.filter.gender,
        sort_by: this.filter.sortBy,
        point: "",
        center_point: "",
        is_prospect: "",
        not_return_days: "",
        last_purchase_branch_id: "0",
        purchase_date_from: "",
        purchase_date_to: "",
        register_date_from: "",
        register_date_to: "",
      };
    },
    LightenDarkenColor(col, amt) {
      var usePound = false;

      if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
      }

      var num = parseInt(col, 16);

      var r = (num >> 16) + amt;

      if (r > 255) r = 255;
      else if (r < 0) r = 0;

      var b = ((num >> 8) & 0x00ff) + amt;

      if (b > 255) b = 255;
      else if (b < 0) b = 0;

      var g = (num & 0x0000ff) + amt;

      if (g > 255) g = 255;
      else if (g < 0) g = 0;

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-slide-btn {
  background-color: #e8e9ec;
  border: none;
}
</style>
